<template>
  <el-dialog :title="title" :visible="visible" width="680px" :before-close="handleClose">
    <div class="good_dialog">
      <el-image class="good_img" :src="newsDialogData.coverImage" :preview-src-list="newsDialogData.imgList"></el-image>
      <div class="good_title">{{ newsDialogData.title }}</div>
      <div class="good_html" v-html="newsDialogData.content"></div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    newsDialogData: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      srcList:[]
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleClose(done) {
      this.$emit("update:visible", false);
      done();
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.good_img {
  width: 640px;
  height: auto;
}
.good_title {
  margin: 30px 0 28px 0;
  font-size: 16px;
  line-height: 1.5rem;
  font-weight: bold;
  color: #333333;
}
.good_html {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 1.5rem;
}
</style>
